/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { UpdateAssetOptions, UpdateAssetResponses } from '../types/UpdateAsset'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Update asset by ID
 * {@link /v1/assets/:asset_id}
 */
export function updateAsset<ThrowOnError extends boolean = true>(
  options: Options<UpdateAssetOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateAssetResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/assets/{asset_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateAssetResponses, ThrowOnError>>,
  )
}
